
import {FirstSection} from "../component/Home/FirstSection";
import {SecondSection} from "../component/Home/SecondSection";
import {ThridSection} from "../component/Home/ThridSection";
import {RatingSection} from "../component/Home/RatingSection";
import {ChallengeSection} from "../component/Home/ChallengeSection";
import {ExamSchedule} from "../component/Home/ExamSchedule";
import {ProcessSection} from "../component/Home/ProcessSection";


export default function Home(){
    return(
          <>
              <style>{
                  `
                  main {
                  max-width: 100% !important;
                  margin:0 !important;
                  }
                  `
              }</style>
              <FirstSection></FirstSection>
              <SecondSection></SecondSection>
              <ThridSection></ThridSection>
              <RatingSection></RatingSection>
              <ChallengeSection></ChallengeSection>
              <ExamSchedule></ExamSchedule>
              <ProcessSection></ProcessSection>
          </>
    )
}